<div class="text-sm">
  <div *ngFor="let item of Object.keys(entities)" class="entity-section">
    <div class="entity-header" (click)="toggleCollapse(item)">
      <button class="collapse-button">{{ collapsedState[item] ? '+' : '-' }}</button>
      <span class="font-medium">{{ item | titleTransform }}</span>
    </div>
    <div *ngIf="!collapsedState[item]" class="entity-content">
      <div *ngIf="typeOfValue(entities[item]) === 'string' || typeOfValue(entities[item]) === 'number' || typeOfValue(entities[item]) === 'date' || entities[item] === null" class="value-main-container">
        <div class="value-container">
          <span *ngIf="!_extraction.isEditEntities">
            {{ entities[item] !== null ? manageSuffix(item, entities[item]) : '-' }}
          </span>
          <input
            *ngIf="_extraction.isEditEntities"
            pInputText
            class="text-sm h-2rem"
            type="text"
            [(ngModel)]="entities[item]"
            [name]="'input' + entities[item]"
            ngDefaultControl
          />
        </div>
      </div>

      <div *ngIf="typeOfValue(entities[item]) === 'array of string' || typeOfValue(entities[item]) === 'array'" class="value-main-container">
        <div class="value-container">
          <ul *ngIf="entities[item]?.length > 0; else emptyArray">
            <li *ngFor="let val of entities[item]; let i = index; trackBy: trackByFn">
              <span *ngIf="!_extraction.isEditEntities">{{ val | titleTransform }}</span>
              <input
                *ngIf="_extraction.isEditEntities"
                pInputText
                class="text-sm h-2rem"
                type="text"
                [(ngModel)]="entities[item][i]"
                [name]="'input' + entities[item][i]"
                ngDefaultControl
              />
            </li>
          </ul>
          <ng-template #emptyArray>
            <div class="text-muted">No items available</div>
          </ng-template>
        </div>
      </div>

      <div *ngIf="typeOfValue(entities[item]) === 'object' && entities[item]" class="value-main-container">
        <div class="value-container">
          <div *ngFor="let val of Object.keys(entities[item] || {})" class="nested-object">
            <div *ngIf="checkObjectOfObjectType(entities[item][val]) !== 'object'" class="nested-value">
              <div class="font-medium nested-key">{{ val | titleTransform }}</div>
              <div ngClass="nested-key-val" *ngIf="!_extraction.isEditEntities">{{ entities[item][val] !== null ? entities[item][val] : '-' }}</div>
              <div class="nested-key-val" *ngIf="_extraction.isEditEntities">
                <input
                  *ngIf="_extraction.isEditEntities"
                  pInputText
                  class="text-sm h-2rem"
                  type="text"
                  [(ngModel)]="entities[item][val]"
                  [name]="'input' + entities[item][val]"
                  ngDefaultControl
                />
              </div>
            </div>
            <app-entity-viewer
              *ngIf="checkObjectOfObjectType(entities[item][val]) === 'object'"
              [entities]="getObjectKeyValue(val, entities[item][val])"
            ></app-entity-viewer>
          </div>
        </div>
      </div>

      <div *ngIf="typeOfValue(entities[item]) === 'array of object'" class="value-main-container">
        <div class="value-container">
          <table class="array-table">
            <thead>
              <tr>
                <th *ngFor="let v of Object.keys(entities[item][0])">{{ v | titleTransform }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let val of entities[item]">
                <td *ngFor="let v of Object.keys(val)">
                  <span *ngIf="!_extraction.isEditEntities">{{ manageSuffix(item, val[v]) }}</span>
                  <input
                    *ngIf="_extraction.isEditEntities"
                    pInputText
                    class="text-sm h-2rem"
                    type="text"
                    [(ngModel)]="val[v]"
                    [name]="'input' + val[v]"
                    ngDefaultControl
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div *ngIf="typeOfValue(entities[item]) === 'array of object of object'" class="value-main-container">
        <div class="value-container">
          <div *ngFor="let val of entities[item]; let i = index">
            <app-entity-viewer [entities]="entities[item][i]"></app-entity-viewer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .entity-section {
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  .entity-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    background-color: var(--surface-300);
    padding: 0.25rem;
    border-radius: 4px;
  }
  .collapse-button {
    background: none;
    border: none;
    font-size: 1rem;
    cursor: pointer;
    margin-right: 0.5rem;
  }
  .value-container {
    margin-top: 0.25rem;
    overflow: auto; /* Ensures content exceeding boundaries is scrollable */
  }

  .entity-content {
    overflow: auto; /* Added to ensure scrollability for nested content */
  }
  .nested-object {
    margin-left: 0.5rem;
    padding-left: 0.5rem;
    border-left: 2px solid var(--surface-400);
  }
  .array-table {
    width: 100%;
    border-collapse: collapse;
  }
  .array-table th, .array-table td {
    border: 1px solid #ddd;
    padding: 0.25rem;
    text-align: left;
  }
</style>
